import { render, staticRenderFns } from "./TableHelperActions.vue?vue&type=template&id=4c774ca6&scoped=true"
import script from "./TableHelperActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHelperActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableHelperActions.vue?vue&type=style&index=0&id=4c774ca6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c774ca6",
  null
  
)

export default component.exports